import { useQuery } from '@tanstack/react-query';
import { getUsdRate } from '@/lib/api/common/exchange.api';

export const exchangeQueryKeys = {
  usdRate: ['exchange', 'usd'] as const,
};

export function useUsdRate(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: exchangeQueryKeys.usdRate,
    queryFn: async () => {
      const rate = await getUsdRate();
      if (rate === null) {
        throw new Error('USD rate not found');
      }
      return rate;
    },
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 30,
  });
}
